// https://www.notion.so/barogohq/1f4363ae08db8063b0dafae41b11636a
/** 미해당 // YN // 자료제출, 결격 없음 */
export const DOCUMENT_SUBMITTED = {
    key: 'DOCUMENT_SUBMITTED',
    text: '미해당',
};
/** 해당 // YY // 자료제출, 결격 있음 */
export const CONVICTED = {
    key: 'CONVICTED',
    text: '해당',
};
/** [기본값] 미제출 // NN // 자료미제출 */
export const DOCUMENT_NOT_SUBMITTED = {
    key: 'DOCUMENT_NOT_SUBMITTED',
    text: '미제출',
};
/** 미제출 // XX // 자료미제출 // 기존사용자, 제외대상자 */
export const NONE = {
    key: 'NONE',
    text: '미제출',
};
export const convictionStatus = {
    DOCUMENT_SUBMITTED,
    CONVICTED,
    DOCUMENT_NOT_SUBMITTED,
    // NONE,
};
